const ConfigurationFactory = require("../ConfigurationFactory");
const Utils = require("../Utils");

const factory = {};

const APPLY_TIMELINE_PARAM = "applyTimeline=";

const RECURRENCE_TYPE = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
};

const DAY_OF_WEEK = {
  SUNDAY: "Sun",
  MONDAY: "Mon",
  TUESDAY: "Tue",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
};

const WEEKDAYS_MAP = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6
};

const msecInOneDay = 1000 * 60 * 60 * 24;

const _safeParseDate = (value) => {
  if (typeof value === 'string') {
    let safeValue = value.replace(/\u202f/, " ");
    return new Date(safeValue);
  } else {
    return new Date(value);
  }
};

const _toDate = (d) => {
  let date;
  if (!d) {
    return null;
  }
  else if (d instanceof Date) {
    date = d;
  }
  else {
    date = _safeParseDate(d);
  }

  const newDate = new Date();
  newDate.setTime(0);
  newDate.setFullYear(date.getFullYear());
  newDate.setDate(date.getDate());
  newDate.setMonth(date.getMonth());

  return newDate;
};

const _toTime = (d) => {
  let date;
  if (!d) {
    return null;
  }
  else if (d instanceof Date) {
    date = d;
  }
  else {
    date = _safeParseDate(d);
  }

  const newDate = new Date();
  newDate.setTime(0);
  newDate.setHours(date.getHours());
  newDate.setMinutes(date.getMinutes());
  newDate.setSeconds(date.getSeconds());

  return newDate;
};

const _daysInMonth = (d) => {
  const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	// check is leap year
  daysInMonths[1] = (parseInt(d.getYear() % 4) === 0) ? 29 : 28;

  return daysInMonths[d.getMonth()];
};

const _diffDays = (fromDate, toDate) => {
  if (!fromDate || !toDate) {
    return -1;
  }

  return parseInt((toDate.getTime() - fromDate.getTime()) / msecInOneDay);
};

const _diffMonths = (fromDate, toDate) => {
  return parseInt(((toDate.getYear() - fromDate.getYear()) * 12) + toDate.getMonth() - fromDate.getMonth());
};

const _diffWeeks = (fromDate, toDate) => {
  const days = _diffDays(fromDate, toDate);
  const weeks = (days + fromDate.getDay()) / 7;

  return parseInt(weeks);
};

const _relativeDate = (date, month, week, weekday) => {
  while (month < 0) {
    month += 12;
  }
  const daysInMonth = _daysInMonth(date);
  let timelineWeek = week;
  if (timelineWeek === 5) {
    const monthStart = _safeParseDate(date);
    monthStart.setDate(1);
    // Calculate how many weekdays are in the given month
    timelineWeek = Math.ceil((daysInMonth - weekday + monthStart.getDay()) / 7);
  }
  let startDay = (new Date(date.getFullYear(), month, 1)).getDay();
  if (startDay > weekday) {
    startDay -= 7;
  }
  let day = 1 + timelineWeek * 7 + weekday - startDay;
  while (day > daysInMonth) {
    day -= 7;
  }
  return day;
};


factory.applies = () => {
  const applyTimeline = Utils.getFromQueryString(APPLY_TIMELINE_PARAM);

  if (applyTimeline) {
    return applyTimeline === 'true';
  } else {
    return ConfigurationFactory.isDisplay() ||
      ConfigurationFactory.isSharedschedule() ||
      ConfigurationFactory.isWebPlayer();
  }
};

factory.canPlay = (item, d) => {
  if (!factory.applies()) {
    return true;
  }

  if (!d) {
    d = new Date();
  }

  if (item.useDisplayTime) {
    // cal.setTimeZone(displayTimeZone);
  }
  else {
    // cal.setTimeZone(minutesToTimeZone(Integer.parseInt(timeZone)));
  }

  if (!item.timeDefined || !item.startDate) {
    return true;
  }


  const t = _toTime(d),
    startDate = _toDate(item.startDate),
    endDate = _toDate(item.endDate),
    startTime = _toTime(item.startTime),
    endTime = _toTime(item.endTime);

  d = _toDate(d);

  if (d < startDate) {
    return false;
  }

  if (!item.noEndDate && endDate && d > endDate) {
    return false;
  }

  if (!item.allDay && (startTime != null) && (endTime != null)) {
    if (startTime < endTime) {
      if (t < startTime || t > endTime)
        { return false; }
    } else if (t < startTime && t > endTime)
      { return false; }
  }

  // -------------------------

  const weekday = d.getDay();
  const dayOfMonth = d.getDate();
  if (item.recurrenceFrequency < 1) {
    item.recurrenceFrequency = 1;
  }

  if (item.recurrenceType === RECURRENCE_TYPE.DAILY) {
    const days = _diffDays(startDate, d);

    if (parseInt(days % item.recurrenceFrequency) != 0) {
      return false;
    }
  } else if (item.recurrenceType === RECURRENCE_TYPE.WEEKLY) {
    const weeks = _diffWeeks(startDate, d);
    // unit test the diffWeeks function
//			String utres ='';
//			utres += diffWeeksUnitTest(new Date(110,3,11), new Date(110,3,11)); //year 2010 in Java = 2010
//			utres += diffWeeksUnitTest(new Date(110,3,17), new Date(110,3,17));
//			utres += diffWeeksUnitTest(new Date(110,3,11), new Date(110,3,17));
//			utres += diffWeeksUnitTest(new Date(110,3,10), new Date(110,3,11));
//			utres += diffWeeksUnitTest(new Date(110,3,10), new Date(110,3,17));
//			utres += diffWeeksUnitTest(new Date(110,3,11), new Date(110,3,18));
//			Window.alert(utres);
    if (parseInt(weeks % item.recurrenceFrequency) != 0) {
      return false;
    }

    if (!_isRecurrenceDay(weekday, item.recurrenceDaysOfWeek)) {
      return false;
    }
  } else if (item.recurrenceType === RECURRENCE_TYPE.MONTHLY) {
    const months = _diffMonths(startDate, d);
    if (item.recurrenceAbsolute) {
      if ((item.recurrenceDayOfMonth !== dayOfMonth) || (parseInt(months % item.recurrenceFrequency) !== 0)) {
        return false;
      }
    } else {
      if ((weekday !== item.recurrenceDayOfWeek) || (parseInt(months % item.recurrenceFrequency) !== 0)) {
        return false;
      }
      // check if the last week of the month is selected recurrenceWeekOfMonth = 5
      if (item.recurrenceWeekOfMonth === 5) {
        if (dayOfMonth <= (_daysInMonth(d) - 7)) {
          return false;
        }
      } else if (item.recurrenceWeekOfMonth != parseInt((dayOfMonth - 1) / 7)) {
        return false;
      }
    }
  } else if (item.recurrenceType === RECURRENCE_TYPE.YEARLY) {
    if (item.recurrenceAbsolute) {
      if (!(((d.getMonth() === item.recurrenceMonthOfYear) && (dayOfMonth === item.recurrenceDayOfMonth)))) {
        return false;
      }
    } else {
      if ((weekday !== item.recurrenceDayOfWeek) || (d.getMonth() !== item.recurrenceMonthOfYear)) {
        return false;
      }
      // check if the last week of the month is selected @RecurrenceWeekOfMonth=5
      if (item.recurrenceWeekOfMonth === 5) {
        if ((dayOfMonth <= (_daysInMonth(d) - 7))) {
	        return false;
        }
      } else if (item.recurrenceWeekOfMonth != parseInt((dayOfMonth - 1) / 7)) {
        return false;
      }
    }
  }

  return true;
};

function _isRecurrenceDay(weekday, recurrenceDaysOfWeek) {
  const dayOfWeeklbl = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"][weekday];
  const currDayCode = DAY_OF_WEEK[dayOfWeeklbl];

  if (recurrenceDaysOfWeek && recurrenceDaysOfWeek.indexOf(currDayCode) >= 0) {
    return true;
  } else {
    return false;
  }
}

factory.lastStarted = (item, d) => {

  if (!item.timeDefined || !item.startDate) {
    return new Date(0);
  }

  if (!d) {
    d = new Date();
  }

  const startDate = _safeParseDate(item.startDate);
  const startTime = _toTime(item.startTime);
  const startDateTime = startTime
    ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startTime.getHours(), startTime.getMinutes(), startTime.getSeconds())
    : new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

  if (startDateTime > d) {
    return null;
  }

  const t = _toTime(d);
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);

  let realStartDate = startTime
    ? new Date(d.getFullYear(), d.getMonth(), d.getDate(), startTime.getHours(), startTime.getMinutes(), startTime.getSeconds())
    : new Date(d.getFullYear(), d.getMonth(), d.getDate());

  if (item.recurrenceFrequency < 1) {
    item.recurrenceFrequency = 1;
  }

  switch (item.recurrenceType) {

    case RECURRENCE_TYPE.DAILY:

      if (item.recurrenceFrequency === 1) {
        if (!item.startTime) {
          // Has been playing continuously since startDate
          return startDate;
        }
        // Has been playing each day at startTime
        if (startTime && t < startTime) {
          realStartDate.setDate(realStartDate.getDate() - 1);
        }
      } else {
        // Has been playing every `recurrenceFrequency` days since startDate
        let days = _diffDays(startDate, d) % item.recurrenceFrequency;
        if (days === 0 && startTime && t < startTime) {
          days += item.recurrenceFrequency;
        }
        realStartDate.setDate(realStartDate.getDate() - days);
      }
      break;

    case RECURRENCE_TYPE.WEEKLY:

      if (!item.recurrenceDaysOfWeek || item.recurrenceDaysOfWeek.length === 0) {
        // Timeline never plays
        return null;
      }
      if (item.recurrenceFrequency === 1 && item.recurrenceDaysOfWeek.length === 7 && !item.startTime) {
        // Has been playing continuously since startDate
        return startDate;
      }
      const recurrenceDays = item.recurrenceDaysOfWeek.map(d => WEEKDAYS_MAP[d]);
      let weeks = _diffWeeks(startDate, d) % item.recurrenceFrequency;
      let thisDay = d.getDay();
      let foundDay = thisDay;

      if (recurrenceDays.indexOf(thisDay) >= 0 && startTime && t < startTime) {
        // Timeline is meant to play on this day, but start time is in the future
        if (recurrenceDays.length === 1) {
          weeks += 1;
        } else {
          foundDay -= 1;
          if (foundDay < 0) {
            foundDay = 6;
            weeks += 1;
          }
        }
      }

      let count = 0;
      while (recurrenceDays.indexOf(foundDay) < 0) {
        foundDay -= 1;
        if (foundDay < 0) {
          foundDay = 6;
          weeks += 1;
        }
        count += 1;
        if (count > recurrenceDays.length) {
          // Something is wrong, can't find a day where content plays
          return null;
        }
      }

      realStartDate.setDate(realStartDate.getDate() - weeks * 7 - thisDay + foundDay);
      if (realStartDate < startDateTime) {
        // Hasn't actually started yet
        return null;
      }
      break;

    case RECURRENCE_TYPE.MONTHLY:

      let months = _diffMonths(startDate, d) % item.recurrenceFrequency;
      let daysPast = d.getDate();
      let recurrenceDate = item.recurrenceAbsolute
        ? item.recurrenceDayOfMonth
        : _relativeDate(realStartDate, d.getMonth(),
            item.recurrenceWeekOfMonth, item.recurrenceDayOfWeek);

      if (months === 0 && (recurrenceDate > daysPast ||
          recurrenceDate === daysPast && item.startTime && t < startTime)) {
        months += 1;
      }
      for (let m = 1; m <= months; m++) {
        daysPast += _daysInMonth(new Date(d.getFullYear(), d.getMonth() - m));
      }
      if (months > 0 && !item.recurrenceAbsolute) {
        recurrenceDate = _relativeDate(realStartDate, d.getMonth() - months,
          item.recurrenceWeekOfMonth, item.recurrenceDayOfWeek);
      }

      realStartDate.setDate(realStartDate.getDate() - daysPast + recurrenceDate);
      if (realStartDate < startDateTime) {
        // Hasn't actually started yet
        return null;
      }
      break;

    case RECURRENCE_TYPE.YEARLY:

      realStartDate = _safeParseDate(startDateTime);
      realStartDate.setMonth(item.recurrenceMonthOfYear);

      if (item.recurrenceAbsolute) {
        realStartDate.setDate(item.recurrenceDayOfMonth);
      } else {
        realStartDate.setDate(_relativeDate(realStartDate, item.recurrenceMonthOfYear,
          item.recurrenceWeekOfMonth, item.recurrenceDayOfWeek));
      }

      while (realStartDate.getFullYear() <= d.getFullYear() - item.recurrenceFrequency) {
        realStartDate.setFullYear(realStartDate.getFullYear() + item.recurrenceFrequency);

        if (!item.recurrenceAbsolute) {
          realStartDate.setDate(_relativeDate(realStartDate, item.recurrenceMonthOfYear,
            item.recurrenceWeekOfMonth, item.recurrenceDayOfWeek));
        }
      }

      if (realStartDate.getTime() > d.getTime()) {
        realStartDate.setFullYear(realStartDate.getFullYear() - item.recurrenceFrequency);

        if (!item.recurrenceAbsolute) {
          realStartDate.setDate(_relativeDate(realStartDate, item.recurrenceMonthOfYear,
            item.recurrenceWeekOfMonth, item.recurrenceDayOfWeek));
        }
      }

      if (realStartDate < startDateTime) {
        // Hasn't actually started yet
        return null;
      }
      break;
  }

  return realStartDate;
};

module.exports = factory;
